import { render, staticRenderFns } from "./AMisRenderer.vue?vue&type=template&id=22244bf6&scoped=true"
import script from "./AMisRenderer.vue?vue&type=script&lang=js"
export * from "./AMisRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22244bf6",
  null
  
)

export default component.exports